module.exports = __webpack_public_path__ + "img/ui-king.ed3aafff.jpg";